<template>
  <el-dialog
    v-dialogDrag
    width="1280px"
    top="2vh"
    class="large-dialog"
    :close-on-click-modal="false"
    :append-to-body="true"
    :visible.sync="formProps.visible"
    :title="formProps.title"
  >
    <el-form
      size="mini"
      label-width="150px"
      v-loading="formLoading"
      :rules="apiRules"
      ref="baseFormData"
      :model="baseFormData"
      :disabled="formProps.editType !== 'create'"
    >
      <el-form-item
        label="排查项目"
        prop="screeningItemsName"
        :rules="[
          {
            required: true,
            message: '请输入名称',
            trigger: ['blur', 'change'],
          },
        ]"
      >
        <el-input
          maxlength="100"
          show-word-limit
          v-model="baseFormData.screeningItemsName"
          placeholder="请输入名称"
          size="small"
          clearable
        />
      </el-form-item>
      <el-form-item label="项目编号" prop="projectCode">
        <el-input
          maxlength="50"
          show-word-limit
          v-model="baseFormData.projectCode"
          placeholder="请输入项目编号"
          size="small"
          clearable
        />
      </el-form-item>
    </el-form>
    <el-form
      size="mini"
      label-width="150px"
      v-loading="formLoading"
      ref="tableFormData"
      :model="tableFormData"
    >
      <div class="text-right mb-10px">
        <el-button type="primary" @click.stop="createRow" size="small" :disabled="disabled"
          >新增</el-button
        >
      </div>
      <el-table max-height="575px" :data="tableData" border class="w-full" stripe>
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column label="排查内容" prop="screeningContent">
          <template slot="header">
            <span class="text-red-500">*</span>
            排查内容
          </template>
          <template slot-scope="scope">
            <el-form-item
              show-overflow-tooltip
              label-width="0px"
              class="mt-20px"
              label=""
              :prop="`${scope.row.formId || scope.row.id}screeningContent`"
              :rules="[
                { required: true, message: '排查内容不能为空', trigger: ['blur', 'change'] },
              ]"
            >
              <el-input
                type="textarea"
                :autosize="{ minRows: 3 }"
                :disabled="disabled"
                class="!w-full"
                maxlength="200"
                show-word-limit
                :placeholder="disabled ? '' : '请输入排查内容'"
                v-model="tableFormData[`${scope.row.formId || scope.row.id}screeningContent`]"
                @change="(value) => tableChange(scope.row, value, 'screeningContent')"
              ></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="排查标准" prop="screeningCriteria">
          <template slot="header">
            <span class="text-red-500">*</span>
            排查标准
          </template>
          <template slot-scope="scope">
            <el-form-item
              show-overflow-tooltip
              label-width="0px"
              class="mt-20px"
              label=""
              :prop="`${scope.row.formId || scope.row.id}screeningCriteria`"
              :rules="[
                {
                  required: true,
                  message: '排查标准不能为空',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-input
                type="textarea"
                :autosize="{ minRows: 3 }"
                :disabled="disabled"
                class="!w-full"
                maxlength="200"
                show-word-limit
                :placeholder="disabled ? '' : '请输入排查标准'"
                v-model="tableFormData[`${scope.row.formId || scope.row.id}screeningCriteria`]"
                @change="(value) => tableChange(scope.row, value, 'screeningCriteria')"
              ></el-input>
            </el-form-item>
          </template>
        </el-table-column>

        <el-table-column label="组织级别" prop="organizationLevel">
          <template slot="header">
            <span class="text-red-500">*</span>
            组织级别
          </template>
          <template slot-scope="scope">
            <el-form-item
              show-overflow-tooltip
              label-width="0px"
              class="mt-20px"
              label=""
              :prop="`${scope.row.formId || scope.row.id}organizationLevel`"
              :rules="[
                {
                  required: true,
                  message: '组织级别不能为空',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-select
                :disabled="disabled"
                class="!w-full edit_table_input"
                v-model="tableFormData[`${scope.row.formId || scope.row.id}organizationLevel`]"
                @change="(value) => tableChange(scope.row, value, 'organizationLevel')"
                :placeholder="disabled ? '' : '请输入组织级别'"
                clearable
              >
                <el-option
                  v-for="item in controlHierarchyList"
                  :key="item.code"
                  :label="item.displayName"
                  :value="Number(item.code)"
                ></el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>

        <el-table-column label="排查周期" prop="inspectionCycle">
          <template slot="header">
            <span class="text-red-500">*</span>
            排查周期
          </template>
          <template slot-scope="scope">
            <el-form-item
              show-overflow-tooltip
              label-width="0px"
              class="mt-20px"
              label=""
              :prop="`${scope.row.formId || scope.row.id}inspectionCycle`"
              :rules="[
                {
                  required: true,
                  message: '排查周期不能为空',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-input-number
                :disabled="disabled"
                :min="1"
                :precision="0"
                class="!w-full"
                show-word-limit
                :placeholder="disabled ? '' : '请输入'"
                v-model="tableFormData[`${scope.row.formId || scope.row.id}inspectionCycle`]"
                @change="(value) => tableChange(scope.row, value, 'inspectionCycle')"
                clearable
              ></el-input-number>
            </el-form-item>
          </template>
        </el-table-column>

        <el-table-column label="单位周期" prop="unitCycle">
          <template slot="header">
            <span class="text-red-500">*</span>
            单位周期
          </template>
          <template slot-scope="scope">
            <el-form-item
              show-overflow-tooltip
              label-width="0px"
              class="mt-20px"
              label=""
              :prop="`${scope.row.formId || scope.row.id}unitCycle`"
              :rules="[
                {
                  required: true,
                  message: '单位周期不能为空',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-select
                :disabled="disabled"
                class="!w-full edit_table_input"
                v-model="tableFormData[`${scope.row.formId || scope.row.id}unitCycle`]"
                @change="(value) => tableChange(scope.row, value, 'unitCycle')"
                :placeholder="disabled ? '' : '请输入单位周期'"
                clearable
              >
                <el-option
                  v-for="item in unitCycleList"
                  :key="item.code"
                  :label="item.displayName"
                  :value="Number(item.code)"
                ></el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>

        <el-table-column label="排查类型" prop="screeningType">
          <template slot="header">
            <span class="text-red-500">*</span>
            排查类型
          </template>
          <template slot-scope="scope">
            <el-form-item
              show-overflow-tooltip
              label-width="0px"
              class="mt-20px"
              label=""
              :prop="`${scope.row.formId || scope.row.id}screeningType`"
              :rules="[
                {
                  required: true,
                  message: '排查类型不能为空',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-select
                :disabled="disabled"
                class="!w-full edit_table_input"
                v-model="tableFormData[`${scope.row.formId || scope.row.id}screeningType`]"
                @change="(value) => tableChange(scope.row, value, 'screeningType')"
                :placeholder="disabled ? '' : '请输入排查类型'"
                clearable
              >
                <el-option
                  v-for="item in checkTypeList"
                  :key="item.value"
                  :label="item.displayName"
                  :value="Number(item.code)"
                ></el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>

        <el-table-column label="操作" fixed="right" width="80">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click.stop="deleteRow(scope.row.formId || scope.row.id)"
              :disabled="disabled || tableData.length === 1"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-form>

    <div slot="footer" class="text-center" v-if="formProps.editType !== 'read'">
      <el-button
        size="small"
        type="primary"
        v-loading="formLoading"
        class="iconfont icon-save"
        @click="save()"
        >保存</el-button
      >
      <el-button size="small" class="iconfont icon-close" @click="cancel()">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { HiddenDangerInspectionChecklistControllApi } from '@wiz-api/double-prevention-management'
import dayjs from 'dayjs'
import utils from '@/components/safety/enumField/utils'

const hiddenDangerInspectionChecklistControllApi = new HiddenDangerInspectionChecklistControllApi()

const uuid = require('uuid')

export default {
  name: 'check-list-base-form',
  props: {
    formProps: {
      type: Object,
      default: () => {
        return {
          title: '新增基础排查清单',
          editType: 'create',
          visible: false,
        }
      },
    },
    formData: {
      type: Object,
      default: () => {},
    },
  },
  components: {},
  data() {
    return {
      oldIds: [],
      controlHierarchyList: [],
      unitCycleList: [],
      checkTypeList: [],
      baseFormData: {},
      tableFormData: {},
      formLoading: false,

      tableData: [],
    }
  },
  watch: {
    'formProps.visible': {
      handler(val) {
        if (!val) {
          this.cancel()
        }
      },
    },
  },
  computed: {
    disabled() {
      return this.formProps.editType === 'read'
    },
  },
  methods: {
    tableChange(row, value, filed) {
      row[filed] = value
    },
    cancel() {
      this.$emit('cancel')
    },
    save() {
      this.$refs.baseFormData.validate((flag) => {
        if (flag) {
          this.$refs.tableFormData.validate(async (valid) => {
            if (valid) {
              this.formLoading = true
              this.baseFormData.creationTime = this.baseFormData.creationTime
                ? dayjs(this.baseFormData.creationTime).format('YYYY-MM-DD HH:mm:ss')
                : this.baseFormData.creationTime
              this.baseFormData.lastModificationTime = this.baseFormData.lastModificationTime
                ? dayjs(this.baseFormData.lastModificationTime).format('YYYY-MM-DD HH:mm:ss')
                : this.baseFormData.lastModificationTime

              const inspectionChecklistDtos = this.tableData.map((item) => {
                return {
                  screeningItemsName: this.baseFormData.screeningItemsName,
                  projectCode: this.baseFormData.projectCode,
                  // ...this.baseFormData,
                  ...item,
                  creationTime: item.creationTime
                    ? dayjs(item.creationTime).format('YYYY-MM-DD HH:mm:ss')
                    : item.creationTime,
                  lastModificationTime: item.lastModificationTime
                    ? dayjs(item.lastModificationTime).format('YYYY-MM-DD HH:mm:ss')
                    : item.lastModificationTime,
                  deletionTime: item.deletionTime
                    ? dayjs(item.deletionTime).format('YYYY-MM-DD HH:mm:ss')
                    : item.deletionTime,
                  inspectionCycle: `${item.inspectionCycle}`,
                }
              })
              // 父级表单必须要传子集的字段随便传值不能为空就行
              const copyChild = JSON.parse(JSON.stringify(inspectionChecklistDtos[0]))
              delete copyChild.id
              const data = {
                ...this.baseFormData,
                ...copyChild,
                inspectionChecklistDtos,
              }
              if (this.formProps.editType === 'create') {
                data.id = uuid()
              } else {
                data.id = this.baseFormData.pid
              }
              const [
                err,
                res,
              ] = await hiddenDangerInspectionChecklistControllApi.saveFoundationClassList({
                body: data,
              })
              if (!err) {
                // 保存成功后同步删除数据
                const list = this.oldIds.filter((id) => {
                  return !this.tableData.find((item) => {
                    return item.id === id
                  })
                })
                if (list.length) {
                  const [
                    delerr,
                    delres,
                  ] = await hiddenDangerInspectionChecklistControllApi.deleteFoundationClassList({
                    guids: list,
                  })
                }
                this.$emit('refreshList')
                this.$emit('cancel')
              }
              this.formLoading = false
            }
          })
        }
      })
    },
    async getData() {},
    createRow() {
      this.tableData.push({
        formId: uuid(),
        id: '00000000-0000-0000-0000-000000000000',
        superiorId: this.baseFormData.superiorId,
      })
    },
    deleteRow(id) {
      this.tableData = this.tableData.filter((item) => {
        if (item.formId) {
          return item.formId !== id
        }
        return item.id !== id
      })
    },
    initData() {
      if (this.formProps.editType === 'create') {
        this.createRow()
      } else {
        const data = JSON.parse(JSON.stringify(this.formData))
        this.tableData = data.inspectionChecklistDtos || []
        // 先存旧的id保存时删除同步
        this.oldIds = this.tableData.map((i) => {
          return i.id
        })
        this.baseFormData = data
        this.tableData.forEach((item) => {
          this.$set(this.tableFormData, `${item.id}screeningContent`, item.screeningContent)
          this.$set(this.tableFormData, `${item.id}screeningCriteria`, item.screeningCriteria)
          this.$set(this.tableFormData, `${item.id}organizationLevel`, item.organizationLevel)
          this.$set(this.tableFormData, `${item.id}inspectionCycle`, item.inspectionCycle)
          this.$set(this.tableFormData, `${item.id}unitCycle`, item.unitCycle)
          this.$set(this.tableFormData, `${item.id}screeningType`, item.screeningType)
        }, {})
      }
    },
  },
  mounted() {
    this.initData()
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.UnitCycle',
        'DoublePreventionManagement.DataCategory.CheckType',
        'DoublePreventionManagement.DataCategory.ControlHierarchy',
      ],
      ['unitCycleList', 'checkTypeList', 'controlHierarchyList'],
      this
    )
  },
}
</script>

<style scoped lang="scss">
.edit_table_input {
  ::v-deep .el-input {
    width: auto;
  }
}
</style>
